import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import BuckProfile from "../components/BuckProfile";
import Loading from "./Loading";
import Error from "./Error";
import HoverButton from "../components/HoverButton";
import { FaArrowLeftLong } from "react-icons/fa6";
import PropTypes from 'prop-types';

function SingleBuck({ isMobile, currentProfile }) {
    const [selectedSite, setSelectedSite] = useState(null);
    const [bucksObject, setBucksObject] = useState(null);
    const [selectedBuck, setSelectedBuck] = useState(null);
    const [failedToFindBuck, setFailedToFindBuck] = useState(false);

    let navigate = useNavigate();

    const { site, buck } = useParams();

    useEffect(() => {
        if(currentProfile && currentProfile.sites) {
            currentProfile.sites.forEach((s) => {
                if(s.slug === site) {
                    setSelectedSite(s);
                }
            });
        }
    }, [currentProfile, site]);

    useEffect(() => {
        if(selectedSite && currentProfile) {
            if(selectedSite.bucksObject) {
                setBucksObject(selectedSite.bucksObject);
            } else {
                selectedSite.getBuck(currentProfile.accessToken, buck).then((response) => {
                    // console.log(response);
                    if(response) {
                        setBucksObject(response);
                    } else {
                        setFailedToFindBuck(true);
                    }
                });
            }
        }
    }, [selectedSite, buck, currentProfile]);

    useEffect(() => {
        if(bucksObject && buck) {
            if(bucksObject.hasOwnProperty(buck)) {
                setSelectedBuck(bucksObject[buck]);
            } else {
                setFailedToFindBuck(true);
            }
        }
    }, [bucksObject, buck]);

    if(currentProfile && selectedBuck) {
        return(
            <div style={{ "minHeight":"92vh" }} className="w3-content w3-container w3-padding-64">
                <div style={isMobile ? {} : { "width": "100%", "display": "flex", "justifyContent": "center" }}>
                    <div>
                        <HoverButton
                            normalIcon={<FaArrowLeftLong style={{ "transform": "scale(2.5)", "color": "grey" }} className="ai-edit-icon" />}
                            hoverIcon={<FaArrowLeftLong style={{ "transform": "scale(2.5)", "color": "black" }} className="ai-edit-icon" />}
                            updateParent={() => { navigate(`/sites/${site}/inventory`); }}
                            title={"Back to Images"}
                            style={isMobile ? { "alignItems": "top", "marginLeft": "3px", "marginRight": "32px", "width": "100%", "justifyContent": "left" } : { "alignItems": "top", "marginLeft": "3px", "marginRight": "32px", "marginTop": "8px" }}
                        />
                    </div>
                    <BuckProfile style={{ "width": "100%" }} isMobile={isMobile} currentProfile={currentProfile} buck={selectedBuck} site={selectedSite} />
                </div>
            </div>
        );
    } else if(currentProfile && failedToFindBuck) {
        return(
            <Error isMobile={isMobile} text={"that buck could not be found."}/>
        );
    } else if(!currentProfile && typeof currentProfile === "boolean") {
        return(
            <Error isMobile={isMobile} type={"login"} />
        );
    } else {
        return(
            <Loading isMobile={isMobile} text={`${buck} profile`}/>
        );
    }
};

SingleBuck.propTypes = {
    isMobile: PropTypes.bool,
    currentProfile: PropTypes.object
};

export default SingleBuck;